import { type InputRule, markTypeInputRule } from "@handlewithcare/prosemirror-inputrules";
import { type MarkType } from "prosemirror-model";

// Given a strong markType returns an input rule that turns `"**text**"` in a text block
// into an <b> tag.
export const strongAsterixRule = (markType: MarkType): InputRule => {
	return markTypeInputRule(/\*\*(?<content>.+)\*\*$/d, markType);
};
